import * as React from 'react';
import HourglassTopRoundedIcon from '@mui/icons-material/HourglassTopRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import BtnFilled from '../../components/BtnOutlined';

const ContentMessage = ({ Icon, title, color }) => {
  return (
    <div className="flex mb-6 items-center">
      <Icon sx={{ width: 32, height: 32 }} className={`text-${color}-500`} />
      <p className="text-gray-800 ml-4 mt-0.5 text-lg font-bold truncate">{title}</p>
    </div>
  );
};

export const StatusRegistration = ({ progress, status, userLoggedIn, confirmHandler }) => {
  return (
    <div className="flex w-full min-h-screen p-4 items-start justify-center bg-gradient-to-r from-[#ededed] to-[#dcdcdc]">
      <div className="w-full max-w-lg bg-white shadow-2xl rounded-3xl border-b border border-gray-200 px-8 pt-6 pb-8 mb-4">
        {progress ? (
          <div className="flex justify-center mb-4">
            <HourglassTopRoundedIcon className="fill-orange-500 animate-spin w-8 h-8" />
          </div>
        ) : status === 'success' ? (
          <ContentMessage Icon={CheckCircleOutlineRoundedIcon} color={'green'} title={'Регистрация успешно подтверждена'} />
        ) : (
          <ContentMessage Icon={CancelRoundedIcon} color={'red'} title={'Ошибка подтверждения регистрации'} />
        )}
        <BtnFilled title={userLoggedIn ? 'Перейти в личный кабинет' : 'Войти'} btnCb={confirmHandler} />
      </div>
    </div>
  );
};
